module.exports = __webpack_public_path__ + "img/1357.843cf589.jpg";